<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'新仙剑丨永安当打卡挑战'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="title"></div>
      <div class="main">
        <div class="code"><img :src="url"></div>
      </div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp } from '@/utils/utils';
export default {
  components: {},
  data () {
    return {
      url :'https://download4.qcplay.com/h5-images/active/hjwq/kfhd/code_img.png'
    };
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.monitoringEquipment();
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `https://h5.qingcigame.com/hjwq/online/enter${getTimeStamp()}`
      }
    }
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/online/pc/index.vue